import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/download.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("View")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ion_item, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_searchbar, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          placeholder: "Search for a subscriber..."
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_list, { style: {"height":"500px","overflow-y":"auto"} }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDataset, (child, index) => {
          return (_openBlock(), _createBlock(_component_ion_item, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, {
                color: child.enabled ? 'success' : 'danger'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(child.componentName), 1),
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(child.location), 1),
                  _hoisted_3,
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(child?.meterId), 1)
                ]),
                _: 2
              }, 1032, ["color"]),
              _createVNode(_component_ion_button, {
                slot: "end",
                onClick: ($event: any) => (_ctx.handleView(child))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (child.projectId > 0)
                ? (_openBlock(), _createBlock(_component_ion_toggle, {
                    key: 0,
                    modelValue: child.enabled,
                    "onUpdate:modelValue": ($event: any) => ((child.enabled) = $event),
                    onClick: ($event: any) => (_ctx.handleToggle($event, child.flexId))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}